import type { GetProductOutput } from '@/http/zamply/products/get-product-schema'
import EnrolmentButton from '@/app/(common)/cursos/info/_components/enrolment-button'
import { useUnity } from '@/hooks/use-unity'

interface FaqProps {
  hasMec: boolean
  product: GetProductOutput
}

export default function Faq({ hasMec, product }: FaqProps) {
  const { unity, template } = useUnity()
  const isEstetusVitrine =
    template === 'template-four' || unity.reference === 'UD2A7AE51'
  const aperfeicoamentoMaxHours = isEstetusVitrine ? '230h' : '300h'

  return (
    <div className="mt-6 space-y-6 md:mt-9">
      {hasMec && (
        <div>
          <h2 className="font-bold text-[#24125C] text-lg md:text-2xl">
            O curso é autorizado pelo MEC?
          </h2>

          <div className="space-y-4">
            <p className="mt-2 font-medium text-[#877E94] text-sm md:text-base">
              Nossos certificados são emitidos por uma instituição reconhecida
              pelo Ministério da Educação (MEC). Os cursos e certificados da
              {unity.full_name} possuem um selo do MEC através de parceria
              consolidada com a Faculdade FAMEC.
            </p>

            <p className="mt-2 font-medium text-[#877E94] text-sm md:text-base">
              Os cursos são promovidos pela {unity.full_name}, que se dedica a
              oferecer uma experiência educacional de qualidade, enquanto a
              certificação é emitida pela Faculdade FAMEC, assegurando que todos
              os cursos atendam aos padrões exigidos pelo MEC.
            </p>

            <p className="mt-2 font-medium text-[#877E94] text-sm md:text-base">
              Essa parceria, reflete nosso compromisso contínuo com a excelência
              na formação profissional de nossos alunos.
            </p>

            <p className="mt-2 font-medium text-[#877E94] text-sm md:text-base">
              Cursos de Extensão, Atualização e Capacitação (até 120h): Esses
              cursos de curta duração são ideais para adquirir novos
              conhecimentos ou atualizar habilidades rapidamente.
            </p>

            <p className="mt-2 font-medium text-[#877E94] text-sm md:text-base">
              Cursos de Aperfeiçoamento, Atualização e Capacitação (acima de
              120h até {aperfeicoamentoMaxHours}): Estes cursos de maior carga
              horária proporcionam um nível aprofundado de conhecimento em uma
              área específica.
            </p>

            {!isEstetusVitrine && (
              <p className="mt-2 font-medium text-[#877E94] text-sm md:text-base">
                Cursos Livres (sem credenciamento pelo MEC - 360h): Além dos
                cursos normatizados pelo MEC, também oferecemos cursos na
                modalidade Livre. Estes são cursos de atualização e capacitação
                com carga horária no certificado de 360 horas.
              </p>
            )}
          </div>
        </div>
      )}

      <div>
        <h2 className="font-bold text-[#24125C] text-lg md:text-2xl">
          Como faço a minha inscrição?
        </h2>

        <div className="mt-2 space-y-2">
          <p className="font-medium text-[#877E94] text-sm md:text-base">
            Para se inscrever, clique no curso que você deseja e depois procure
            pelo botão verde “INSCREVA-SE". Se você já tiver conectado(a) no
            site, a sua inscrição será confirmada apenas com um clique. Caso não
            esteja, insira seus dados na tela seguinte para confirmar sua
            inscrição.
          </p>

          <p className="mt-2 font-medium text-[#877E94] text-sm md:text-base">
            ATENÇÃO: Antes de inscrever-se no seu primeiro curso, é necessário
            que você já tenha um cadastro no site. Caso ainda não tenha se
            cadastrado <EnrolmentButton product={product} variant="secondary" />
          </p>
        </div>
      </div>
    </div>
  )
}
